import React from 'react'
import TrackVisibility from 'react-on-screen'

export type WithTrackVisibilityProps = {
  isVisible: boolean
}

export function withTrackVisibility<T>(
  WrappedComponent: React.ComponentType<T>
): (props: Omit<T, keyof WithTrackVisibilityProps>) => JSX.Element {
  const ComponentWithTrackVisibility = (props) => {
    return (
      <TrackVisibility partialVisibility once>
        <WrappedComponent key={WrappedComponent.displayName} {...props} />
      </TrackVisibility>
    )
  }
  ComponentWithTrackVisibility.displayName = `withTrackVisibility(${WrappedComponent.displayName})`

  return ComponentWithTrackVisibility
}
